/* eslint-disable react-hooks/exhaustive-deps */
import { useMutation } from '@apollo/client';
import { useMemo } from 'react';

import { AbandonUsageHeader, AbandonUsageHeaderVariables }
  from '@/graphql/contracts/_generated_/abandonUsageHeader.mutation';
import AbandonUsageHeaderMutation from '@/graphql/contracts/abandonUsageHeader.mutation.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';

interface AbandonUsageHeaderParams {
  usageHeaderId: string;
  onSuccess?: () => void;
}

export function useAbandonUsageHeader() {
  const [abandon] = useMutation<AbandonUsageHeader, AbandonUsageHeaderVariables>(
    AbandonUsageHeaderMutation,
    {
      client: apolloClientContracts,
      onError: (err) =>
        notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger',
        }),
    },
  );

  const abandonUsageHeader = ({ usageHeaderId, onSuccess }: AbandonUsageHeaderParams) => {
    abandon({
      variables: {
        id: usageHeaderId,
      },
      onCompleted: (response) => {
        if (response?.abandonUsageHeader) {
          onSuccess?.();
          notificationService.open({
            title: 'Delete Usage Header',
            text: 'Usage header deleted successfully',
            type: 'success',
          });
        }
      },
    });
  };

  return useMemo(
    () => ({
      abandonUsageHeader,
    }),
    [],
  );
}
